import { FlexRow } from '@components'
import { BaseText } from '../BaseText'
import { DataCompletenessDot } from './DataCompletenessDot'
import type { DataCompletenessType } from './dataCompletenessIndicator.utils'

interface DataCompletenessLegendItemProps {
  type: DataCompletenessType
  text: string
}

export const DataCompletenessLegendItem = ({ type, text }: DataCompletenessLegendItemProps) => {
  return (
    <FlexRow alignItems={'center'} gap={'8px'}>
      <DataCompletenessDot type={type} />
      <BaseText fontSize={'12px'} color={'secondaryForeground'}>
        {text}
      </BaseText>
    </FlexRow>
  )
}
